/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppWithLanguages } from '../../models/app-with-languages';

export interface LanguagesTranslationsControllerFindAllWithTranslatedLanguages$Params {
}

export function languagesTranslationsControllerFindAllWithTranslatedLanguages(http: HttpClient, rootUrl: string, params?: LanguagesTranslationsControllerFindAllWithTranslatedLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppWithLanguages>>> {
  const rb = new RequestBuilder(rootUrl, languagesTranslationsControllerFindAllWithTranslatedLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppWithLanguages>>;
    })
  );
}

languagesTranslationsControllerFindAllWithTranslatedLanguages.PATH = '/languages-translations/with-translated-languages';
